import { safeRemoveChild } from "helpers/safeRemoveChild";

export const handleBlobFile = (blob, props) => {
  const { name, openNewTab = false, download = false } = props;
  const url = window.URL.createObjectURL(blob);

  if (openNewTab) {
    window.open(url, '_blank');
  }

  if (download) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name || 'download');
    document.body.appendChild(link);
    link.click();
    safeRemoveChild(link);
  }

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 1000);
}
